import { useEffect, useRef, useState } from "react";

// Click-to-edit text. Saves on blur / Enter, cancels on Escape.
export function InlineText({ value, onSave, placeholder = "—", type = "text", multiline = false, className = "", testId, prefix = "" }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => { if (!editing) setDraft(value || ""); }, [value, editing]);
  useEffect(() => { if (editing && ref.current) { ref.current.focus(); ref.current.select?.(); } }, [editing]);

  const commit = async () => {
    setEditing(false);
    const next = draft.trim();
    if (next === (value || "").trim()) return;
    await onSave(next);
  };

  const onKey = (e) => {
    if (e.key === "Escape") { setDraft(value || ""); setEditing(false); }
    if (e.key === "Enter" && (!multiline || e.metaKey || e.ctrlKey)) { e.preventDefault(); commit(); }
  };

  if (editing) {
    const Tag = multiline ? "textarea" : "input";
    return (
      <Tag
        ref={ref}
        type={multiline ? undefined : type}
        value={draft}
        rows={multiline ? 3 : undefined}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={onKey}
        data-testid={testId ? `${testId}-input` : undefined}
        className={`w-full bg-[#FFFDF5] border-b border-[#0A0A0A] outline-none px-1 py-0.5 text-sm ${multiline ? "resize-none leading-relaxed" : ""} ${className}`}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setEditing(true)}
      data-testid={testId}
      title="Click to edit"
      className={`text-left w-full px-1 py-0.5 -mx-1 border-b border-transparent hover:border-dashed hover:border-[#BBB] hover:bg-[#FAFAFA] transition-colors ${!value ? "text-[#B5B5B5]" : ""} ${multiline ? "whitespace-pre-wrap leading-relaxed" : "truncate"} ${className}`}
    >
      {value ? `${prefix}${value}` : placeholder}
    </button>
  );
}
